import React from 'react';
import ExpertConnectionPageShell from '../components/ExpertConnectionPageShell';

export default function ExpertConnection() {
  return <ExpertConnectionPageShell />;
}
